import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Clean placeholder page for modules referenced by the desktop chrome
 * that don't have a dedicated screen yet. All links stay functional.
 */
export default function ModulePlaceholder({ title, icon, description, related }) {
  const navigate = useNavigate();
  return (
    <div>
      <div className="toolbar">
        <div className="toolbar-left"><h2>{icon} {title}</h2></div>
      </div>
      <div className="card">
        <div className="empty-state">
          <div className="empty-icon">{icon}</div>
          <h3>{title}</h3>
          <p>{description || `The ${title} module is part of the LedgerPro roadmap.`}</p>
          {related && related.length > 0 && (
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap', marginTop: 12 }}>
              {related.map(r => (
                <button key={r.label} className="btn btn-outline btn-sm" onClick={() => navigate(r.path)}>
                  {r.label}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
